import React, { useEffect, useState } from "react";
import {
  AsyncCallArgs,
  FormSection,
  GridContainer,
  GridItem,
  RadiosFormField,
  useAsyncCall,
} from "@duosoftbg/nacid-components";
import { getDocumentReceiveOptionsByKind } from "../../../../../../services/coreServicesCalls";
import ReceiverAddressFormSection from "../address/ReceiverAddressFormSection";
import { useFormContext } from "react-hook-form";

const DocumentReceiveOptionFormSection = ({ titleCode = "t.originalDocumentReceive.way", baseField, kind }) => {
  const { setValue } = useFormContext();
  const { asyncCall } = useAsyncCall();
  const [options, setOptions] = useState(null);

  useEffect(() => {
    setValue(`${baseField}.optionKind.id`, kind);
    const calcFeesArgs: AsyncCallArgs = {
      promise: getDocumentReceiveOptionsByKind(kind),
      processResponseErrors: false,
      withGlobalBackdrop: false,
      onSuccess: (response) => {
        setOptions(response.data);
      },
      onError: () => {},
    };
    asyncCall(calcFeesArgs);
  }, [baseField, kind, asyncCall]);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <>
      <FormSection label={titleCode}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <RadiosFormField
              required={true}
              onChange={(e) => {
                const selectedCode = e.target.value;
                const selectedOption = options.find((opt) => opt.id === selectedCode);
                setValue(`${baseField}.resultReceive.documentRecipient`, selectedOption.documentRecipient);
              }}
              fieldName={`${baseField}.resultReceive.id`}
              radioOptions={options.map((option) => {
                return { value: option.id, text: option.name };
              })}
            ></RadiosFormField>
          </GridItem>
        </GridContainer>
      </FormSection>
      <ReceiverAddressFormSection baseField={baseField} />
    </>
  );
};
export default DocumentReceiveOptionFormSection;
